var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"xs12":""}},[_c('v-card',[_c('h1',[_vm._v("TAKT.ing Authentication")]),_c('h2',[_vm._v("Logging you in save and sound...")]),_c('h3',[_vm._v("Loading User Data...")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }